import { action, makeObservable, observable } from 'mobx';
import ParticipantsStore from '../ParticipantsStore';
import { ParticipantResource } from '../ParticipantsStore/Types';

class ParticipantStore {
  readonly resource: ParticipantResource;

  @observable
  participantChecked: boolean = false;

  participantsStore: ParticipantsStore;

  constructor(participantsStore: ParticipantsStore, resource: ParticipantResource) {
    makeObservable(this);
    this.participantsStore = participantsStore;
    this.resource = resource;
  }

  @action
  updateParticipantChecked = (checked: boolean) => {
    this.participantChecked = checked;
  };
}

export default ParticipantStore;
